import { TrendingMarkerProps } from '../../types/components/shared/TrendingMarker';

export const defaultClasses = 'bg-[#ffe81a] text-[#000] uppercase text-[12px] h-[20px] px-[6px] py-[1px] rounded-[3px] font-bold flex items-center';

const TrendingMarker: React.FC<TrendingMarkerProps> = ({
  trending,
  className,
}) => {
  if (!trending) return;

  return (
    <div className={`${defaultClasses}${className ? ` ${className}` : ''}`} cy-test-id="trending-marker">
      trending
    </div>
  );
};

export default TrendingMarker;
